// extracted by mini-css-extract-plugin
module.exports = {"card-container":"llmdZ","text-wrapper":"_22uYW","headline":"u4i6-","subheadline":"_2abjh"};